var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('svg',{staticClass:"svg unselectable",staticStyle:{"border":"1px solid red","background":"#2D3039"},attrs:{"id":"svg"},on:{"drop":_vm.handleDrop,"dragover":_vm.allowDrop}}),_vm._v(" "),_c('button',{on:{"click":_vm.getData}},[_vm._v("获取数据")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.2@vue-loader/lib/template-compiler?{"id":"data-v-3c5f6af2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/DataFlow/index.vue
// module id = null
// module chunks = 